<div class="wrapper-page gifts-page">
  <div class="wrapper-header-page">
    <div class="overlay-illustration-header"></div>
  </div>
  <div class="wrapper-content-page">
    <div class="wrapper-header-page-content">
      <span class="header-text">Početna</span>
    </div>
    <div class="wrapper-dashboard-content">
      <div class="grid">
        <div class="grid__m-4">
          <div class="zc-card-wrapper dashboard-card">
            <div class="header-card">
              <span class="title-card">Registrovani korisnici</span>
              <span class="number-card">{{ dashboardData?.users.count }}</span>
            </div>
            <div class="content-card">
              <gr-area-chart [data]="{name: 'Reg. korisnici', data: dashboardData?.users.growth}" [chartColor]="'#5BA2DD'"></gr-area-chart>
            </div>
          </div>
        </div>
        <div class="grid__m-4">
          <div class="zc-card-wrapper dashboard-card">
            <div class="header-card">
              <span class="title-card">Kupljeni pokloni</span>
              <span class="number-card active">{{ dashboardData?.gifts.count }}</span>
            </div>
            <div class="content-card">
              <gr-area-chart [data]="{name: 'Kupljeni pokloni', data: dashboardData?.gifts.growth}" [chartColor]="'#74C34C'"></gr-area-chart>
            </div>
          </div>
        </div>
        <div class="grid__m-4">
          <div class="zc-card-wrapper dashboard-card">
            <div class="header-card">
              <span class="title-card">Rezervacije</span>
              <span class="number-card inactive">{{ dashboardData?.reservations.count }}</span>
            </div>
            <div class="content-card">
              <gr-area-chart [data]="{name: 'Rezervacije', data: dashboardData?.reservations.growth}" [chartColor]="'#FF0000'"></gr-area-chart>
            </div>
          </div>
        </div>
        <div class="grid__m-6">
          <div class="zc-card-wrapper dashboard-card">
            <div class="header-card">
              <span class="title-card">Aktivni biznis korisnici</span>
              <span class="number-card active">{{ dashboardData?.active_companies.count }}</span>
            </div>
          </div>
        </div>
        <div class="grid__m-6">
          <div class="zc-card-wrapper dashboard-card">
            <div class="header-card">
              <span class="title-card">Neaktivni biznis korisnici</span>
              <span class="number-card inactive">{{ dashboardData?.inactive_companies.count }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


